import { connect } from 'react-redux';
import { fetchConfigurations } from 'reducers/paymentConfiguration/actions';
import getConfigurationList from 'selectors/getConfigurationList';
import isExperienceComplete from 'selectors/isExperienceComplete';
import { fetchExperiences, completeExperience } from 'reducers/ftue/actions';
import {
  selectConfiguration,
  deselectConfiguration,
  startCreation,
  stopCreation,
  unload,
} from 'reducers/paymentConfiguration/ui/actions';
import { FTUE_PAYMENT_CONFIG_PAGE_TOUR } from 'reducers/ftue/ftueKeys';
import { bindActionCreators } from 'redux';
import PaymentConfiguration from './PaymentConfiguration';

function mapStateToProps(state) {
  const {
    selectedConfigurationId,
    isCreatingNew,
  } = state.paymentConfiguration.ui;

  return {
    isCreatingNew,
    selectedConfigurationId,
    showFtue: !isExperienceComplete(state, FTUE_PAYMENT_CONFIG_PAGE_TOUR),
    configurations: getConfigurationList(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onLoad: () => {
      dispatch(fetchConfigurations());
      dispatch(fetchExperiences());
    },
    onTourComplete: () => {
      dispatch(completeExperience(FTUE_PAYMENT_CONFIG_PAGE_TOUR));
    },
    ...bindActionCreators(
      {
        selectConfiguration,
        deselectConfiguration,
        startCreation,
        stopCreation,
        onUnload: unload,
      },
      dispatch
    ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentConfiguration);
